import React from 'react';
import locale from '../../common/locale'
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const Spinner = require('react-spinkit');

const Loading = () => {
  const loc = cookies.get('locale')
  return (
    <div className='loading' style={{
      transform: `translate3d(
        ${window.innerWidth/2-200}px,
        ${window.innerHeight/2-60}px, 0px)`}} >
        <h3>{locale.title_one(loc)}<i className="fas fa-share-alt fa-lg" />{locale.title_two(loc)}<br />node-node-node</h3>
      <section>loading...</section>
      <Spinner name="line-scale-pulse-out-rapid" />
    </div>
  )
}

export default Loading




// WEBPACK FOOTER //
// ./src/components/fixedComponents/Loading.js